<!--
 * =====================================================================
 * 작 업 명  : 회원가입
 * 파 일 명  : Join.vue
 * 변경이력
 * 2022-01-29 / 정태화 / 최초작성
 * 2022.02-15 / 경다찬 / 메일 발송, 수신 코드, ID 중복체크 작성
 * 2022-03-10 / 임태민 / 컴포넌트 분리, 모듈화
 * 2022-03-10 / 임태민 / 기능 및 유효성체크 추가, 수정
 * 2022-03-10 / 임태민 / 글자수 제한
 * 2022-03-10 / 임태민 / 유효성체크 추가
 * =====================================================================
 -->
<template>
  <div>
    <div class="text mt-3 mb-3">
      <h4><b>Confirm Your Details</b></h4>
    </div>
    <div class="text mb-5">
      <h5>
        We'd like some additional information before creating your account
      </h5>
    </div>
    <form>
      <div class="row">
        <!-- SEX_TYPE -->
        <div class="col mb-3">
          <div class="form-floating">
            <select
              class="form-select"
              id="sex"
              v-model="this.userChild.SEX_TYPE"
            >
              <option value="" selected disabled>Select your gender</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="X">Unchecked</option>
            </select>
            <label for="sex">Gender</label>
          </div>
          <div ref="SEX_TYPE" class="check red" role="alert">&nbsp;</div>
        </div>
        <!-- BIRTH_TYPE -->
        <!-- <div class="col-sm-6 mb-3">
                    <div class="form-floating">
                        <select class="form-select" id="birthday-type" v-model="this.userChild.BIRTH_TYPE">
                            <option value="S">Solar</option>
                            <option value="L">Lunar</option>
                        </select>
                        <label for="birthday-type">Birth type</label>
                    </div>
                </div> -->
      </div>
      <div class="row">
        <!-- BIRTH DATE -->
        <div class="col mb-3">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="birth-day"
              v-model="this.userChild.BIRTH_DAY"
              placeholder="YYYYMMDD"
              maxlength="8"
            />
            <label for="birth-day">Birth Date(YYYYMMDD)</label>
          </div>
          <div ref="BIRTH_DAY" class="check red" role="alert">&nbsp;</div>
        </div>
      </div>
      <div class="row">
        <!-- MOBILE -->
        <div class="col-sm-6 mb-3">
          <div class="form-floating">
            <Phone id="mobile" v-model="this.userChild.MOBILE"></Phone>
            <label for="mobile">Mobile</label>
          </div>
          <div ref="MOBILE" class="check red" role="alert">&nbsp;</div>
        </div>

        <!-- TEL -->
        <div class="col-sm-6 mb-3">
          <div class="form-floating">
            <Phone id="telephone" v-model="this.userChild.TEL"></Phone>
            <label for="telephone">Telephone</label>
          </div>
          <div ref="TEL" class="check red" role="alert">&nbsp;</div>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="addr1"
              v-model="this.userChild.ADDR1"
            />
            <label for="addr1">Address</label>
          </div>
        </div>
        <!-- <div class="col mb-3">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="addr2" v-model="this.userChild.ADDR2">
                        <label for="addr2">Address 2</label>
                    </div>
                </div> -->
      </div>
      <!-- <div class="row">
                <div class="col-sm-6">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="area" v-model="this.userChild.AREA" maxlength="50">
                        <label for="area">State/Province</label>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="zip-code" v-model="this.userChild.ZIP_CODE" maxlength="10">
                        <label for="zip-code">Zip(12345-1234)</label>
                    </div>
                    <div ref="ZIP_CODE" class="check red" role="alert">&nbsp;</div>
                </div>
            </div> -->
      <div class="row">
        <div ref="ERRORS" class="check red" role="alert">&nbsp;</div>
      </div>
      <div class="row">
        <div class="col mt-3 mb-3">
          <button
            type="button"
            class="btn btn-outline-dark btn-lg rounded-pill w-100"
            @click="prev()"
          >
            Back
          </button>
        </div>
        <div class="col mt-3 mb-3">
          <button
            type="button"
            class="btn btn-dark btn-lg rounded-pill w-100"
            @click="submit()"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import "@/assets/css/formLayout.css";
import { $axios, $error } from "@/dot-ui/index.js";
import Phone from "@/components/control/Phone.vue";

export default {
  props: ["user", "fromParams"],
  data() {
    return {
      userChild: {},
    };
  },
  components: {
    Phone,
  },
  created() {
    this.userChild = this.user;
  },
  methods: {
    // 이전화면으로 이동
    prev() {
      this.$emit("prev", this.userChild, "showJoin2");
    },
    // 다음화면으로 이동
    next() {
      this.$emit("changeData", this.userChild, "showJoin4");
    },
    //회원가입 클릭
    async submit() {
      // 클래스(.check) 폼 초기화
      $error.clearForm("check");

      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;
      this.userChild.fromSiteNo = fromSiteNo;
      this.userChild.fromCompNo = fromCompNo;

      let url = "/user-app/v2/users";
      let param = this.userChild;
      let response = await $axios.post(url, param);

      if (response.status === 201) {
        this.next();
      } else {
        $error.showMessage(response, this);
        $error.focus(response);
      }
    },
  },
};
</script>
<style></style>
